import { 
	ApiService,
    ImageService,
    LessonService, 
    ListingModalService,
    ContentService, 
    ObserverService,
    LocalStorageService,
    ShepherdService
} from '@DavisDigital/davisdigitalfrontend.module';

import { ContentModuleTypes, EVENTS, FolderTypes } from '@DavisDigital/interfaces';
import { LessonListStorageKeys } from '@DavisDigital/controllers/lesson-listing';

import * as Shepherd from '../../../../../org/Hibachi/client/lib/shepherd.js/dist/js/shepherd.min.js'

class LessonEditorController {
	
	public displaySideMenu: boolean = false;
	public displayMobileEditMenu: boolean = false;
	public draggable: boolean = true;
	public errors;
	
	public hasLoaded: boolean = false;
	public isLoading: boolean = false;
	public isSaving: boolean = false;
	public lessonNameEditMode:boolean = false;
	public viewType:string = "";

	public lesson;
	public nextLessonIndex=1;
	public permissions;
	public splitExampleText:string = `
		<p>
			This is the default Split Layout module. Click here to replace this text with your lesson content. 
			You can copy & paste from another or document or type directly into the box. You can change the default 
			image by clicking the image icon at the bottom left of the default image.
		</p>
	`;
	
	public lessonsListLink: string;
	public davisAccountType:string;

	// @ngInject
	constructor(
		private ModalService,
		private $anchorScroll	: ng.IAnchorScrollService,
		private $filter			: ng.IFilterService,
		private $location       : ng.ILocationService,
		public  $rootScope      : ng.IRootScopeService,
		public  $timeout		: ng.ITimeoutService,
		private apiService		: ApiService,
		private imageService    : ImageService,
		private lessonService   : LessonService,
		private contentService  : ContentService,
		private observerService : ObserverService,
		private listingModalService : ListingModalService,
		private localStorageService : LocalStorageService,
		private davisAlertService,
		private shepherdService
	) {
		this.lessonsListLink = `/lessons?lessonType=${this.localStorageService.getItem(LessonListStorageKeys.LastTab)}`;
		if (this.localStorageService.getItem(LessonListStorageKeys.LastSelectedFolder)) {
			this.lessonsListLink += `&folderID=${this.localStorageService.getItem(LessonListStorageKeys.LastSelectedFolder)}`
		}
	}
	
	
	public $onInit = () => {
		this.$anchorScroll.yOffset = 200;
			
		var lessonID = this.$location.search().lessonID;
		this.viewType = this.$location.search().view;
		
		if(this.viewType == null){
			this.setViewType('edit');
		}
		
		if( lessonID != null && lessonID.length ){
			
			this.registerEvents(lessonID);
			
			this.isLoading = true; 
			
			this.lessonService.getLessonDetails( lessonID ).then(
				(response)=>{

					this.setLesson(response.data); 
					this.permissions = this.apiService.getPermissions();
					
					//check if lesson is archived / don't have edit permission and if it's being open in edit mode
					if( (response.data.archiveFolder_folderID.trim() != '' || !response.data.canEdit) && this.viewType === 'edit' ) {
						//change view type to present
						this.setViewType("present");
					}
					
					
				}
			).finally(()=>{
				if(this.viewType === 'edit'){
					this.shepherdService.existingLessonEdit();
				}
			});
			
		} else {
			
			this.registerEvents();
			
			this.lesson = {};
			this.lesson.contentModules = [];
			this.lesson.contentModules.push(this.contentService.newContentModule(ContentModuleTypes.SPLIT, 1, this.splitExampleText));
			
			this.lesson.lessonType = {};
			
			var lessonType = this.$location.search().lessonType
		
			if(lessonType != null){
				this.lesson.lessonType.systemCode = lessonType;
			} else {
				this.lesson.lessonType.systemCode = 'ltUser';
			}
			
						
			this.observerService.attach(this.setLesson,  EVENTS.SET_LESSON);
			
			this.hasLoaded = true;
			
			if(this.viewType === 'edit' && this.hasLoaded){
				this.shepherdService.newLessonEdit("new");
			}
		}
	}
	
	public launchShepherd = () =>{
		this.shepherdService.existingLessonEdit(true);
	}
	
	public setDavisAccountType = (accountType) => {
		this.davisAccountType = accountType;
	}
	
	public $onDestroy = () =>{
		this.deregisterEvents(this.lesson.lessonID);
		this.lesson = null;
		this.hasLoaded = false; 
		this.isLoading = true;
		
		Shepherd.off('cancel');
		Shepherd.off('complete');
		
	}
	
	public setViewType = (viewType) =>{
		
		//additional check to prevent any edge cases
		if( viewType == "edit" && this.lesson && !this.lesson.canEdit) {
			viewType = "present";
		}
		
		this.viewType = viewType;
		this.$location.search( 'view', this.viewType );
		this.observerService.notify('viewType', this.viewType)
	}
	
	public toggleDisplaySideMenu = (clickOutside = true) =>{
		
		if(!clickOutside && this.displaySideMenu) return; 
		
		this.displaySideMenu = !this.displaySideMenu;
	}
	
	public toggleDisplayMobileEdit = (clickOutside = true) =>{
		
		if(!clickOutside && this.displayMobileEditMenu) return; 
		
		this.displayMobileEditMenu = !this.displayMobileEditMenu;
	}
	
	public toggleLessonNameEdit = () =>{
		this.lessonNameEditMode = !this.lessonNameEditMode; 
		
		if(!this.lessonNameEditMode){
			this.saveLesson();
		}
	}
	
	public deregisterEvents = (lessonID?) =>{
		if(lessonID){
			this.observerService.detachById(lessonID);
		} else {
			this.observerService.detachByEvent(EVENTS.ADD_CONTENT)
			this.observerService.detachByEvent(EVENTS.UPDATE_CONTENT)
			this.observerService.detachByEvent(EVENTS.DELETE_CONTENT)
			this.observerService.detachByEvent(EVENTS.SAVE_LESSON)
			this.observerService.detachByEvent(EVENTS.SET_LESSON)
		}
	}
	
	public registerEvents = (lessonID?) =>{
		
		if(lessonID?.length === 32){
			this.observerService.attach(this.addContentModule,      EVENTS.ADD_CONTENT,      lessonID);
			this.observerService.attach(this.updateContentModule,   EVENTS.UPDATE_CONTENT,   lessonID);
			this.observerService.attach(this.deleteContentModule,   EVENTS.DELETE_CONTENT,   lessonID);
			this.observerService.attach(this.saveLesson,            EVENTS.SAVE_LESSON,      lessonID);
			this.observerService.attach(this.setLesson,             EVENTS.SET_LESSON,  	 lessonID);
			this.observerService.attach(this.setLessonErrors,       EVENTS.SET_LESSON_ERRORS,lessonID);
		} else {
			this.observerService.attach(this.addContentModule,      EVENTS.ADD_CONTENT);
			this.observerService.attach(this.updateContentModule,   EVENTS.UPDATE_CONTENT);
			this.observerService.attach(this.deleteContentModule,   EVENTS.DELETE_CONTENT);
			this.observerService.attach(this.saveLesson,            EVENTS.SAVE_LESSON);
			this.observerService.attach(this.setLesson,             EVENTS.SET_LESSON);
			this.observerService.attach(this.setLessonErrors,       EVENTS.SET_LESSON_ERRORS);
		}
		
		this.observerService.attach(this.updateSortOrder, 'contentModuleSortOrderUpdated');
	}
	
	public addContentModule = (contentModule) =>{
		
		this.updateSortOrder( this.lesson.contentModules, contentModule );
		
		if( contentModule.contentModuleType_systemCode === ContentModuleTypes.BOOK ||
			contentModule.contentModuleType_systemCode === ContentModuleTypes.VIDEO ||
			contentModule.contentModuleType_systemCode === ContentModuleTypes.IMAGE ||
			contentModule.contentModuleType_systemCode === ContentModuleTypes.BUTTON ||
			contentModule.contentModuleType_systemCode === ContentModuleTypes.EMBEDDED
		){
			
			if(this.lesson.lessonID?.length != 32){
				this.lesson.contentModules.splice(contentModule.sortOrder, 0, contentModule);
			}
			
			this.saveLesson({ 
				contentModule: contentModule
			});
			
		} else {
			this.lesson.contentModules.splice(contentModule.sortOrder, 0, contentModule);
		}
		
		this.lesson.contentModules = this.$filter('orderBy')(this.lesson.contentModules, '+sortOrder');
		
	}
	
	public nextLesson = () =>{
		if(!this.lesson.folder.lessons[this.nextLessonIndex]) return;
		
		this.$location.search('lessonID', this.lesson.folder.lessons[this.nextLessonIndex].lessonID);
		this.$onDestroy();
		this.$onInit();
		this.nextLessonIndex++;
	}
	
	public previousLesson = () =>{
		if(!this.lesson.folder.lessons[this.nextLessonIndex - 2]) return;
		
		this.$location.search('lessonID', this.lesson.folder.lessons[this.nextLessonIndex-2].lessonID);
		this.$onDestroy();
		this.$onInit();
		this.nextLessonIndex--;
	}
	
	public editContentModuleTitle = (contentModule) => {
	
		if(!contentModule.title?.trim().length){
			contentModule.title = contentModule.contentModuleType_typeName;
		}
		
		contentModule.editingTitle = !contentModule.editingTitle;
		
		this.draggable = !contentModule.editingTitle;
		
		if(!contentModule.editingTitle){
			this.contentService.saveContentModule(contentModule).then(()=>{
				//do nothing 
			})
		}
	}
	
	public scrollToContentModule = (contentModule: any) => {
		
		this.displaySideMenu = false;
		
		var contentModuleID = 'cm' + contentModule.contentModuleID;
		
		this.$anchorScroll(contentModuleID);
	}
	
	public updateContentModule = (contentModule) => {
		
		for(var i=0; i<this.lesson.contentModules.length; i++){
			
			if(this.lesson.contentModules[i].contentModuleID === contentModule.contentModuleID){
				this.lesson.contentModules[i] = contentModule; 
				
				this.saveLesson({
					contentModule: contentModule
				})
				break;
			}
			
		}
	}
	
	public updateSortOrder = ( contentModules, contentModule? ) => {
		
		var contentModulesToUpdate = [];
		var seenIndices = [];
		
		
		for( var i=0; i <= this.lesson.contentModules.length; i++){
			
			if( this.lesson.contentModules[i] == null ) continue;
			
			if( !contentModule ){
				
				this.lesson.contentModules[i].sortOrder = i;
				
				contentModulesToUpdate.push( this.lesson.contentModules[i] );
				
			} else if ( 
				this.lesson.contentModules[i].sortOrder >= contentModule.sortOrder
			){
			
				this.lesson.contentModules[i].sortOrder++;
				contentModulesToUpdate.push( this.lesson.contentModules[i] );
			
			}
			
			while(seenIndices.indexOf(this.lesson.contentModules[i].sortOrder) > -1){
				this.lesson.contentModules[i].sortOrder++;
			}	
			
			seenIndices.push(this.lesson.contentModules[i].sortOrder);
		}
		
		this.contentService.updateSortOrder(contentModulesToUpdate);
		
		this.lesson.contentModules = this.$filter('orderBy')(this.lesson.contentModules, '+sortOrder')
	}
	
	public deleteContentModule = (args) =>{
		
		if( args.contentModule.contentModuleID == null ||
			args.contentModule.contentModuleID.length !== 32
		){
			this.lesson.contentModules.splice(args.position, 1);
		} else {
			this.contentService.deleteContentModule(args.contentModule).then((result)=>{
				
				if( result.data.success ){
					return this.removeContentModule( args.contentModule.contentModuleID );
				}
				
				if( result.data.message === 'No content module with ID found' ){
					return this.lesson.contentModules.splice(args.position, 1);	
				}
			})
		}
	}
	
	private removeContentModule = (contentModuleID) =>{
		for(var i=0; i<this.lesson.contentModules.length; i++){
			if(contentModuleID === this.lesson.contentModules[i].contentModuleID){
				this.lesson.contentModules.splice(i, 1);
				break;
			}
		}
	}
	
	public createLesson = () =>{
		this.isLoading = true; 
		this.lessonService.createLesson("Needs title").then((response)=>{
			this.isLoading = false; 
			
			this.lesson = response; 
		});
	}
	
	public togglePublish = () =>{
		if(!this.lesson.publishedFlag){
			return this.publishLesson();
		} else {
			return this.unpublishLesson();
		}
	}
	
	public publishLesson = () =>{
		if(!this.lesson.lessonID) return; 
	
		this.isSaving = true; 
		
		return this.lessonService.publishLesson(this.lesson).then(
			(response)=>{
				this.isSaving = false; 
				
				if(response.successfulActions.length){
					this.lesson.publishedFlag = true; 
				}
			}
		);
	}
	
	public unpublishLesson = () => {
		if(!this.lesson.lessonID) return; 
		
		this.isSaving = true; 
		
		return this.lessonService.unpublishLesson(this.lesson).then(
			(response)=>{
				this.isSaving = false; 
				
				if(response.successfulActions.length){
					this.lesson.publishedFlag = false; 
				}
			}
		);
	}
	
	public onEditDescription = () => {
		this.ModalService.showModal({
			component: 'editLessonDescriptionModal',
			bodyClass: 'angular-modal-service-active',
			bindings: {
				lesson: this.lesson,
			},
			preClose: (modal) => {
				modal.element.modal('hide');
				this.ModalService.closeModals();
			},
		})
		.then((modal) => {
			//it's a bootstrap element, use 'modal' to show it
			modal.element.modal('show');
			modal.close.then((lesson) => {
			    if(lesson){
			        this.lesson = lesson;
			    }
			});
		});
	}
	
	public saveToMyLessons = () =>{
		this.listingModalService.launchDuplicateModal(this.lesson, null, (success) => {
	        if( success ){ 
	        }
	    });
	}
	
	public saveLesson = (args={}) =>{
		
		if(!this.lesson.lessonID){
			this.launchSaveAsModal();
			return; 
		}
		
		this.errors = null;
		this.isSaving = true;
			
		return this.lessonService.saveLesson(this.lesson, args).then((response) => {
			
			if(response == null){
				this.davisAlertService.error('Could not save lesson, recieved empty response.'); 
				return; 
			}
			
			
			if(!response.data.success){
				this.errors = response.data.errors;
				
			} else {
				
				this.davisAlertService.success('Lesson has been saved.');
				
				this.observerService.notify(EVENTS.SET_LESSON, response.data.lesson );
			}
			
			this.isSaving = false;
		});
	}
	
	public setLessonErrors = (lessonErrors) =>{
		this.errors = lessonErrors;
	}
	
	public setLesson = (lesson) =>{
		
		if( this.$location.search().lessonID == null){
			this.$location.search( 'lessonID', lesson.lessonID );
			this.registerEvents(lesson.lessonID);
		}
		
		if(lesson.contentModules){
			lesson.contentModules = this.$filter('orderBy')(lesson.contentModules, '+sortOrder')
		}
		
		if(lesson.imageMap){
			this.imageService.setImageMap(lesson.imageMap).then((imageMap)=>{
				this.$timeout(()=>{
					this.lesson = lesson;
				});
			}).finally(()=>{
				this.observerService.notify(EVENTS.UPDATE_CONTENT_MODULES);
			});
		} else {
			this.lesson = lesson;
			this.observerService.notify(EVENTS.UPDATE_CONTENT_MODULES);
		}
		
		this.isLoading = false; 
		this.hasLoaded = true;
	}
	
	private launchSaveAsModal(){
    	this.lessonService.getMyLessonFolders({ showAll: true, ignoreArchiveFolder: true })
    	.then((result) => {
    		let allFolders = result.data.records;
    		this.ModalService.showModal({
    			component: 'saveAsModal',
    			bodyClass: 'angular-modal-service-active',
    			bindings: {
    				type: FolderTypes.Lesson,
    				folders: allFolders,
    				lesson: this.lesson
    			},
    			preClose: (modal) => {
    				modal.element.modal('hide');
    				this.ModalService.closeModals();
    			},
    		}).then((modal) => {
    			//it's a bootstrap element, use 'modal' to show it
    			modal.element.modal('show');
    			modal.close.then((result) => {});
    		});
    	});
	}
	
	public onExport = () => {
		
		var anchor = document.createElement('a');
        anchor.href = '?slatAction=davisdigital:api.exportLessons&apiData.lessonID=' + this.lesson.lessonID + '&apiData.downloadNowFlag=true';
        anchor.target = '_blank';
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
	}

	public onShare = () => {
	    this.listingModalService.launchShareSettingModal(this.lesson.title,this.lesson.lessonID,'lesson',"",Function,{}, this.davisAccountType != "Student");
	}

}

export { LessonEditorController };
